// Full-document render of the stearns OfferIndexPage: PageSkeleton (the React
// document shell) wrapping the OfferIndexPage {% block layout %} DOM -- the
// <div class="offer-index-page u-full-width-title"> wrapper (class-anchored
// chrome the offer-index stylesheet targets) around the existing offer-content
// body island. The CollectionPage-typed JSON-LD and the offer-index page
// stylesheet are carried in page_chrome.
import React from "react";

import { templates } from "@reactivated";

import { OfferIndexPageBody } from "../components/OfferIndexPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed with
// mutable reactivated props. The body template accepts Immutable props, to which
// these are assignable.
export const Template = (
    props: templates.OfferIndexPageTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <div className="offer-index-page u-full-width-title">
            <OfferIndexPageBody page={props.page} />
        </div>
    </PageSkeleton>
);
